import { render, staticRenderFns } from "./WizardHeader.vue?vue&type=template&id=132f8bb3&scoped=true&"
import script from "./WizardHeader.vue?vue&type=script&lang=js&"
export * from "./WizardHeader.vue?vue&type=script&lang=js&"
import style0 from "./WizardHeader.vue?vue&type=style&index=0&id=132f8bb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132f8bb3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132f8bb3')) {
      api.createRecord('132f8bb3', component.options)
    } else {
      api.reload('132f8bb3', component.options)
    }
    module.hot.accept("./WizardHeader.vue?vue&type=template&id=132f8bb3&scoped=true&", function () {
      api.rerender('132f8bb3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/vistas/modals/wizard/components/WizardHeader.vue"
export default component.exports